export const Sdata = [
  {
    id: 1,
    title: "Adishi",
    image: "/images/myimages/Adishi/Adishi_Sunset.jpg",
    descKey: "singlePageTranslations.Adishi_Desc",
    paraImage_one: "/images/myimages/Adishi/adishi.webp",
    paraImage_two: "/images/myimages/Adishi/adishi2.jpg",
  },
  {
    id: 2,
    title: "Hatsvali",
    image: "/images/myimages/khatsvali/hatsvali.jpeg",
    descKey: "singlePageTranslations.Hatsvali_Desc",
    paraImage_one: "/images/myimages/khatsvali/khatsvali2.jpg",
    paraImage_two: "/images/myimages/khatsvali/khatsvali3.webp",
  },
  {
    id: 3,
    title: "Laghami",
    image: "/images/myimages/Laghami/lagami.jpg",
    descKey: "singlePageTranslations.Laghami",
    paraImage_one: "/images/myimages/Laghami/laghami2.jpg",
    paraImage_two: "/images/myimages/Laghami/laghami3.jpg",
  },
  {
    id: 4,
    title: "Georgian National Museum",
    image: "/images/myimages/Museum/2.jpg",
    descKey: "singlePageTranslations.NationalMuseum",
    paraImage_one: "/images/myimages/Museum/1.jpg",
    paraImage_two: "/images/myimages/Museum/3.jpg",
  },
];

export default Sdata;
